/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 兑换好礼
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ExchangeGiftsListParams {
  constructor(public activityId: string) {}
}

export default async function (
  params: ExchangeGiftsListParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.GetExchangeGiftsListResponse;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/exchangeGiftsList`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
